import styled from "@emotion/styled";

export default styled.div`
  display: flex;
  gap: 80px;
  padding: 20px;

  .description-section {
    max-width: 400px;
    h2 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    ul {
      list-style-type: disc;
      padding-left: 20px;
    }
    li {
      margin-bottom: 15px;
      font-size: 14px;
      color: #555;
      line-height: 1.5;
    }
  }

  .recommendations-section {
    flex-grow: 1;
  }

  .recommendation-level {
    margin-bottom: 25px;
    h3 {
      font-weight: bold;
      margin-bottom: 10px;
      font-size: 16px;
    }
    textarea {
      width: 100%;
      min-height: 120px;
      border-radius: 12px;
      border: 1px solid #f0f0f0;
      padding: 15px;
      font-size: 14px;
      background-color: #fafafa;
      resize: vertical;
      font-family: inherit;
      margin-bottom: 10px;

      &::placeholder {
        color: #b0b0b0;
      }
      &:focus {
        outline: none;
        border-color: #b0b0b0;
        background-color: white;
      }
    }

    .link-input-container {
      display: flex;
      gap: 10px;

      input {
        flex: 1;
      }
    }

    input[type="url"],
    input[type="text"] {
      width: 100%;
      height: 40px;
      border-radius: 12px;
      border: 1px solid #f0f0f0;
      padding: 15px;
      font-size: 14px;
      background-color: #fafafa;
      font-family: inherit;

      &::placeholder {
        color: #b0b0b0;
      }
      &:focus {
        outline: none;
        border-color: #b0b0b0;
        background-color: white;
      }
    }
  }

  .save-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
`;
